import React from 'react';
import PropTypes from 'prop-types';
import { renderToString } from 'react-dom/server';
import { spring, StaggeredMotion } from 'react-motion';
import { Image, SharingPopup } from 'C4';

const Collection = (props) => {
  const { content, header } = props;

  // Dynamically Create enough animation starting values
  const startingValues = [];
  Object.keys(content).map(() => {
    const newObj = {};
    newObj.pos = 0;
    return startingValues.push(newObj);
  });

  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'y',
    },
    buttons: ['thumbs', 'share', 'download', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={window.location.href} />),
    },
    caption: header,
  };

  return (
    <div className="collection__Container">
      <div className="collection__Container--title">
        <h3>{header}</h3>
      </div>
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
          ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
          : { pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
      >
        {styles => (
          <div className="collection__Grid">
            {Object.values(content).map((item, index) => {
              const {
                pageID, title, url, type,
              } = item;

              let { image } = item;
              if (!image) {
                image = 'https://front.travpromobile.com/500/question-top.jpg';
              }

              if (header === 'malibu competitive analysis' || header === 'axis competitive analysis' || header === 'dealer programs' || header === 'product overview') {
                return (
                  <div className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                    <Image
                      key={url}
                      src={image}
                      gradient
                      onLoad={() => { this.setState({ loading: false }); }}
                      href={url}
                      fancybox={url}
                      options={fancyOptions}
                      share={false}
                      caption={title}
                    />
                    <div className="title">{title}</div>
                  </div>
                );
              }

              if (url === 'https://front.travpromobile.com/500/1571408442-2019-malibu-final.pdf' || url === 'https://front.travpromobile.com/500/1570637991-modelspecs.pdf' ||
                   url === 'https://front.travpromobile.com/500/1570637976-boatspecs.pdf' || url === 'https://front.travpromobile.com/500/1570638147-competitivealignment.pdf' ||
                   url === 'https://front.travpromobile.com/500/1570638158-centurion.pdf' || url === 'https://front.travpromobile.com/500/1570642759-compalignment.pdf' ||
                   url === 'https://front.travpromobile.com/500/1570642823-mastercraft.pdf' || url === 'https://front.travpromobile.com/500/1570642785-moomba.pdf' ||
                   url === 'https://front.travpromobile.com/500/1570642795-supreme.pdf' || url === 'https://front.travpromobile.com/500/1571845606-1570637576-labordaysale.pdf' ||
                   url === 'https://front.travpromobile.com/500/1571845639-2019-malibu-yese-final-1.pdf' || url === 'https://front.travpromobile.com/500/1571845659-2019-axis-yese-final-1.pdf' ||
                   url === 'https://front.travpromobile.com/500/1571655725-xt-series.mp4' || url === 'https://front.travpromobile.com/500/1571655048-malibu-22-lsv-vs-mastercraft-xt22.mp4' ||
                   url === 'https://front.travpromobile.com/500/1571655286-malibu-22-mxz-vs-mastercraft-x23.mp4' || url === 'https://front.travpromobile.com/500/1573589593-malibufacilitystandardsnew.pdf' ||
                   url === 'https://front.travpromobile.com/500/1573589525-2019-malibu-yese-final.pdf' || url === 'https://front.travpromobile.com/500/1571933560-1570637991-modelspecs-rotated.pdf' ||
                   url === 'https://front.travpromobile.com/500/1578582646-2020axisbsp.pdf' || url === 'http://front.travpromobile.com/500/1578582636-2020malibubsp.pdf' || url === 'https://front.travpromobile.com/500/1578582636-2020malibubsp.pdf' ||
                   url === 'https://front.travpromobile.com/500/1579192553-gsseriesnoshare.mp4' || url === 'https://front.travpromobile.com/500/1579197638-2019moombamaxnoshare.mp4' || url === 'https://front.travpromobile.com/500/1579198134-2019moombamojonoshare.mp4' ||
                   url === 'https://front.travpromobile.com/500/1579198338-2019mastercraftxt22noshare.mp4' || url === 'https://front.travpromobile.com/500/1579198993-tigenoshare.pdf' || url === 'https://front.travpromobile.com/500/1579198987-centurionnoshare.pdf' ||
                   url === 'https://front.travpromobile.com/500/1579198974-nautiquenoshare.pdf') {
                    return (
                      <div className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                        <Image
                          key={url}
                          src={image}
                          gradient
                          onLoad={() => { this.setState({ loading: false }); }}
                          href={url}
                          fancybox={url}
                          options={fancyOptions}
                          share={false}
                          caption={title}
                        />
                        <div className="title">{title}</div>
                      </div>
                    );
               }

              if (type === 'pdf') {
                  return (
                    <div className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                      <Image
                        key={url}
                        src={image}
                        gradient
                        onLoad={() => { this.setState({ loading: false }); }}
                        href={`https://stack.travpromobile.com/viewer.php?file=${url}`}
                        fancybox={`https://stack.travpromobile.com/viewer.php?file=${url}`}
                        options={fancyOptions}
                        caption={title}
                      />
                      <div className="title">{title}</div>
                    </div>
                  );
              }

              if (type === 'videolink') {
                return (
                  <div className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                    <Image
                      key={url}
                      src={image}
                      gradient
                      onLoad={() => { this.setState({ loading: false }); }}
                      href={url}
                      fancybox={url}
                      options={fancyOptions}
                      caption={title}
                    />
                    <div className="title">{title}</div>
                  </div>
                );
              }

              return (
                <div className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    <Image
                      key={url}
                      src={image}
                      caption={title}
                      gradient
                      onLoad={() => { this.setState({ loading: false }); }}
                    />
                    <div className="title">{title}</div>
                  </a>
                </div>
              );
            })}
          </div>
        )}
      </StaggeredMotion>
    </div>
  );
};

export default Collection;

Collection.propTypes = {
  content: PropTypes.arrayOf.isRequired,
  header: PropTypes.string,
};

Collection.defaultProps = {
  header: '',
};
